/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import SiteConsumption from './LCBlocks/SiteConsumption';
import SiteStats from './LCBlocks/SiteStats';
import EnergyConsumptionForecast from './LCReports/EnergyConsumptionForecast';
import EnergyConsumptionHistorical from './LCReports/EnergyConsumptionHistorical';
import PowerFlowForecast from './LCReports/PowerFlowForecast';
import PowerFlowHistorical from './LCReports/PowerFlowHistorical';
import {
  fetchLCAppAnalytics,
  uploadFileToServer,
} from '../../Service/APIService';
import { showToast } from '../../utils/helper';
import SpinnerIcon from '../Custom/SpinnerIcon';
import { session } from '../../Service/APIService';
import axios from '../../utils/axiosClient';

const intRegExp = new RegExp('^(0|[1-9][0-9]*)$');

const init = {
  BatteryCapacityMaxKwh: 100, // accept -ve and decimal numeric
  BatteryCapacityMinKwh: 0, // accept -ve and decimal numeric
  BatteryChargeRateKw: 50, // accept -ve and decimal numeric
  BatteryDischargeRateKw: 25, // accept -ve and decimal numeric
  ChargingStartTimeHours: 0, //int
  ChargingEndTimeHours: 24, //int
  DischargingStartTimeHours: 26, //int
  DischargingEndTimeHours: 46, //int
  SolarCapacityKwp: 100, // accept -ve and decimal numeric
  lat: 0, // accept -ve and decimal numeric
  lon: 0, // accept -ve and decimal numeric
  Objective: 'cost_with_solar',
  deviceId: 12193, //int
};
const LowCarbonAnalyticsTab = () => {
  const [data, setData] = useState([]);
  const [stats, setStats] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [inputs, setInput] = useState(init);
  const [uploadFile, setUploadFile] = useState();
  const [checked, setChecked] = useState();
  const [assetNames, setAssetNames] = useState([]);

  useEffect(() => {
    fetchData();
    fetchAssetNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = (handler) => {
    setLoading(true);
    const reqObj = {
      ...inputs,
      BatteryCapacityMaxKwh: parseFloat(inputs.BatteryCapacityMaxKwh),
      BatteryCapacityMinKwh: parseFloat(inputs.BatteryCapacityMinKwh),
      BatteryChargeRateKw: parseFloat(inputs.BatteryChargeRateKw),
      BatteryDischargeRateKw: parseFloat(inputs.BatteryDischargeRateKw),
      SolarCapacityKwp: parseFloat(inputs.SolarCapacityKwp),
      lat: parseFloat(inputs.lat),
      lon: parseFloat(inputs.lon),
    };
    fetchLCAppAnalytics(handler || inputs.deviceId, reqObj)
      .then((res) => {
        setData(res.data.results);
        setStats(res.data.stats);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const fetchAssetNames = () => {
    const sessionId = session.client();
    const url = `Asset/AssetsByClient/${sessionId}`;
    axios
      .get(url)
      .then((res) => {
        const data = res.data.statusCode === 200 ? res.data.result : [];
        setAssetNames(data);
      })
      .catch((err) => {
        console.log(err);
        setAssetNames([]);
      });
  };

  const handleChange = (e) => {
    const {
      target: { name, value },
    } = e;

    const intTypes = [
      'ChargingStartTimeHours',
      'ChargingEndTimeHours',
      'DischargingStartTimeHours',
      'DischargingEndTimeHours',
    ];

    if (intTypes.includes(name)) {
      if (value === '' || intRegExp.test(value)) {
        setInput({ ...inputs, [name]: value === '' ? '' : Number(value) });
      }
    } else {
      setInput({ ...inputs, [name]: value });
    }
  };

  const submitForm = async () => {
    if (checked) {
      setLoading(true);
      let bodyFormData = new FormData();
      let fileToUpload = uploadFile[0];
      bodyFormData.append('file', fileToUpload);
      bodyFormData.append('lat', checked);
      bodyFormData.append('lon', checked);

      uploadFileToServer(bodyFormData)
        .then((response) => {
          const handler = response.status === 200 && response.data.handle;
          fetchData(handler);
        })
        .catch((err) => {
          showToast(err.message, 'error');
        });
    } else {
      fetchData();
    }
  };

  const renderCharts = () => (
    <>
      <Row>
        <Col md={8}>
          <SiteStats data={stats} />
        </Col>
        <Col md={4}>
          <SiteConsumption data={data} />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <EnergyConsumptionHistorical data={data} isLoading={isLoading} />
        </Col>
        <Col md={6}>
          <EnergyConsumptionForecast data={data} />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <PowerFlowHistorical data={data} />
        </Col>
        <Col md={6}>
          <PowerFlowForecast data={data} />
        </Col>
      </Row>
    </>
  );

  const renderItem = isLoading ? (
    <div className="activity-indicator">
      <div className="spinner">
        <SpinnerIcon />
      </div>
    </div>
  ) : (
    renderCharts()
  );

  return (
    <>
      <Row>
        <Col lg={2}>
          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Battery capacity Max</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.BatteryCapacityMaxKwh}
                  name="BatteryCapacityMaxKwh"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Battery capacity Min</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.BatteryCapacityMinKwh}
                  name="BatteryCapacityMinKwh"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Lat</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.lat}
                  name="lat"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
        </Col>
        <Col lg={2}>
          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Battery Charge &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.BatteryChargeRateKw}
                  name="BatteryChargeRateKw"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>

          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Battery Discharge</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.BatteryDischargeRateKw}
                  name="BatteryDischargeRateKw"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>

          <FormGroup>
            <Col lg={12}>
              <Col lg={8}>
                <span>Lon</span>
              </Col>
              <Col lg={4} style={{ marginBottom: '5px' }}>
                <input
                  type="text"
                  value={inputs.lon}
                  name="lon"
                  className="form-control"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
        </Col>
        <Col lg={2}>
          <Col lg={8}>
            <span>Charging Start Time</span>
          </Col>
          <Col lg={4} style={{ marginBottom: '5px' }}>
            <input
              type="text"
              value={inputs.ChargingStartTimeHours}
              name="ChargingStartTimeHours"
              className="form-control"
              onChange={handleChange}
            />
          </Col>

          <Col lg={8}>
            <span>Charging End Time</span>
          </Col>
          <Col lg={4} style={{ marginBottom: '5px' }}>
            <input
              type="text"
              value={inputs.ChargingEndTimeHours}
              name="ChargingEndTimeHours"
              className="form-control"
              onChange={handleChange}
            />
          </Col>

          <Col lg={8}>
            <span>SolarCapacity</span>
          </Col>
          <Col lg={4} style={{ marginBottom: '5px' }}>
            <input
              type="text"
              value={inputs.SolarCapacityKwp}
              name="SolarCapacityKwp"
              className="form-control"
              onChange={handleChange}
            />
          </Col>
        </Col>
        <Col lg={2}>
          <Col lg={8}>
            <span>Discharging Start Time</span>
          </Col>
          <Col lg={4}>
            <input
              type="text"
              value={inputs.DischargingStartTimeHours}
              name="DischargingStartTimeHours"
              className="form-control"
              onChange={handleChange}
            />
          </Col>

          <Col lg={8}>
            <span>Discharging End Time</span>
          </Col>
          <Col lg={4}>
            <input
              type="text"
              value={inputs.DischargingEndTimeHours}
              name="DischargingEndTimeHours"
              className="form-control"
              onChange={handleChange}
            />
          </Col>
          <Col lg={12}>
            {' '}
            <span>
              <input
                type="checkbox"
                onChange={(e) => setChecked(e.target.checked)}
              />
              &nbsp; Do you have your site demand file?
            </span>
          </Col>
        </Col>
        <Col lg={4}>
          <Col lg={6} style={{ marginTop: '5px' }}>
            <span>Objective</span>
          </Col>
          <Col lg={6} style={{ marginBottom: '7px' }}>
            <select
              className="form-control"
              name="Objective"
              onChange={handleChange}
            >
              <option value="cost_with_solar">cost_with_solar</option>
              <option value="cost_without_solar">cost_without_solar</option>
            </select>
          </Col>

          <Col lg={6} style={{ marginTop: '5px' }}>
            <span>Device Id</span>
          </Col>
          <Col lg={6} style={{ marginBottom: '7px' }}>
            <input
              type="text"
              value={inputs.deviceId}
              name="deviceId"
              className="form-control"
              onChange={handleChange}
            />
          </Col>

          <Col lg={6} style={{ marginTop: '5px' }}>
            <span>Asset</span>
          </Col>
          <Col lg={6} style={{ marginBottom: '7px' }}>
            <select
              className="form-control"
              name="deviceId"
              onChange={handleChange}
            >
              <option value="">--Select--</option>
              {assetNames.map((asset, index) => (
                <option key={'asst' + index} value={asset.assetId}>
                  {asset.assetName}
                </option>
              ))}
            </select>
          </Col>
          {checked && (
            <Col lg={7}>
              <div>
                <input
                  type="file"
                  onChange={(e) => setUploadFile(e.target.files)}
                />
              </div>
            </Col>
          )}
          <Col
            lg={5}
            style={{
              justifyContent: 'center',
              display: 'flex',
              marginTop: '5px',
            }}
          >
            <button
              className="btn btn-md btn-success"
              onClick={() => submitForm()}
            >
              Submit
            </button>
          </Col>
        </Col>
      </Row>
      {renderItem}
    </>
  );
};
export default LowCarbonAnalyticsTab;
